import {
  ADD_CALL_FOR_ACTION_ASYNC,
  CHANGE_CALL_FOR_ACTION_PROPERTY,
  EDIT_CALL_FOR_ACTION_ASYNC,
  GET_CALL_FOR_ACTION_ASYNC,
  RESET_CALL_FOR_ACTION,
} from './constants'

const addCallForAction = (forceSave) => ({
  type: ADD_CALL_FOR_ACTION_ASYNC.INITIATE,
  payload: { forceSave },
})
export const addCallForActionSuccess = () => ({
  type: ADD_CALL_FOR_ACTION_ASYNC.SUCCESS,
})
export const addCallForActionError = (error) => ({
  type: ADD_CALL_FOR_ACTION_ASYNC.ERROR,
  error,
})
const addCallForActionCancel = () => ({
  type: ADD_CALL_FOR_ACTION_ASYNC.CANCEL,
})

export const editCallForAction = (id, forceSave) => ({
  type: EDIT_CALL_FOR_ACTION_ASYNC.INITIATE,
  payload: { id, forceSave },
})
export const editCallForActionSuccess = () => ({
  type: EDIT_CALL_FOR_ACTION_ASYNC.SUCCESS,
})
export const editCallForActionError = (error) => ({
  type: EDIT_CALL_FOR_ACTION_ASYNC.ERROR,
  error,
})
export const editCallForActionCancel = () => ({
  type: EDIT_CALL_FOR_ACTION_ASYNC.CANCEL,
})

const changeCallForActionProperty = (value, propertyName) => ({
  type: CHANGE_CALL_FOR_ACTION_PROPERTY,
  payload: { value, propertyName },
})
const resetCallForAction = () => ({ type: RESET_CALL_FOR_ACTION })

export const getCallForAction = (id) => ({
  type: GET_CALL_FOR_ACTION_ASYNC.INITIATE,
  payload: { id },
})
export const getCallForActionSuccess = (callForAction) => ({
  type: GET_CALL_FOR_ACTION_ASYNC.SUCCESS,
  payload: { callForAction },
})
export const getCallForActionError = (error) => ({
  type: GET_CALL_FOR_ACTION_ASYNC.ERROR,
  error,
})
const getCallForActionCancel = () => ({
  type: GET_CALL_FOR_ACTION_ASYNC.CANCEL,
})

export default {
  // to props
  addCallForAction,
  addCallForActionCancel,
  changeCallForActionProperty,
  resetCallForAction,
  getCallForAction,
  getCallForActionCancel,
  editCallForAction,
}
